import { DashboardWrapper } from "../../container/dashboardWrapper"
import { Link } from 'react-router-dom';

const Forum = () => {
    return (
        <DashboardWrapper>
            <Link to="/">Go home</Link>
            <Link to="/account">Go account</Link>
        </DashboardWrapper>
    )
}

export default Forum
